<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="customerDutyAudits && customerDutyAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="customerDutyAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Crew Duty audits </ng-template>
</ng-template>
